module.exports = __webpack_public_path__ + "img/diagnose1.1bb93f1b.jpg";